import React from 'react'
import PropTypes from 'prop-types'
import Photo from '../photos/photo'
import SVGLoader from '../svg/loader'

const TeamPhotosTab = ({ photos, loading, onSelectPhoto }) => {
  if (loading) {
    return (
      <div className="px-4 py-5 text-center">
        <SVGLoader className="text-primary" width={24} height={24} />
        <p className="mb-0 mt-3 text-uppercase">
          <strong>Loading photos...</strong>
        </p>
      </div>
    )
  }

  if (!photos || photos.length === 0) {
    return (
      <div className="px-4 py-3 text-center">
        <p className="lead mb-0">
          <strong className="d-block text-uppercase">No photos uploaded yet!</strong>
        </p>
      </div>
    )
  }

  return (
    <div className="px-4 py-3">
      <div className="photo-list row no-gutters">
        {photos.map(photo => (
          <div key={photo.id} className="col-4 col-md-3 py-0 px-0 text-center">
            <Photo photo={photo} onClick={() => onSelectPhoto(photo)} />
          </div>
        ))}
      </div>
    </div>
  )
}

TeamPhotosTab.propTypes = {
  photos: PropTypes.array,
  loading: PropTypes.bool,
  onSelectPhoto: PropTypes.func.isRequired,
}

TeamPhotosTab.defaultProps = {
  photos: [],
  loading: false,
}

export default TeamPhotosTab
